import {IFilter} from "@/services/filters/types/IFilter";
import {Excursion} from "@/services/excursions/types";
import {ExcursionFilter} from "@/services/filters/types";

export default class NumberFilter extends IFilter {
    private type = "number";
    private min: number;
    private max: number;
    public values: [number, number] = [0, 0];
    public options: Record<string, string>

    constructor(filter: ExcursionFilter,options: Record<string,string>) {
        super(filter.name, filter.code.toLocaleLowerCase());
        this.max = 0;
        this.min = 9999999;
        this.options = options
    }

    setValues(from: number, to: number) {
        if (from) {
            this.values[0] = from;
        }
        if (to) {
            this.values[1] = to;
        }
    }

    reset() {
        this.values = [this.min, this.max];
    }

    from_string(value: string) {
        const values = value.split('-');
        this.values[0] = +values[0];
        this.values[1] = +values[1];
    }

    changed(): boolean {
        return this.max !== this.values[1] || this.min !== this.values[0];
    }

    to_string(): string {
        return `${this.values[0]}-${this.values[1]}`;
    }

    initialize(excursions: Excursion[]) {
        let min = 9999999;
        let max = 0;

        excursions.forEach(excursion => {
            const value = +excursion[this.key];
            min = Math.min(value, min);
            max = Math.max(value, max);
        });

        this.min = min;
        this.max = max;
        this.values = [min, max];
        return true;
    }

    test(excursion: Excursion): boolean {

        const value = +excursion[this.key];

        if (!this.changed()) {
            return true;
        }

        return value === undefined || value <= this.values[1] && value >= this.values[0];
    }
}
